import { FeatureFlagChannel } from '@tableau/microview-communication-service/lib/src/channelDefinitions/FeatureFlagChannelDefinitions';

export enum FeatureFlag {
  collectionsSiteSetting = 'collectionsSiteSetting',
  extractMoveToTheWebEnabled = 'extractMoveToTheWebEnabled',
  datasourceCertificationEnabled = 'datasourceCertificationEnabled',
  metricsReferenceLineEnabled = 'metricsReferenceLineEnabled',
  metricsColorIndicatorsEnabled = 'metricsColorIndicatorsEnabled',
  metricsDateWindowEnabled = 'metricsDateWindowEnabled',
  metricsSpaceEnabled = 'metricsSpaceEnabled',
  metricsHistoricalComparisonsEnabled = 'metricsHistoricalComparisonsEnabled',
  metricsEditingEnabled = 'metricsEditingEnabled',
  personalSpaceEnabled = 'personalSpaceEnabled',
  databasesInProjectsEnabled = 'databasesInProjectsEnabled',
  databasesInProjectsPostMVPEnabled = 'databasesInProjectsPostMVPEnabled',
  tablesInProjectsEnabled = 'tablesInProjectsEnabled',
  tablesInProjectsUIEnabled = 'tablesInProjectsUIEnabled',
  predictiveModelEnabled = 'prometheusPredictiveModelEnabled',
  searchDraftsEnabled = 'searchDraftsEnabled',
  metricsDataCatalogEnabled = 'metricsDataCatalogEnabled',
  writableFieldDescriptionsEnabled = 'writableFieldDescriptionsEnabled',
  fieldDescriptionInheritanceLineageEnabled = 'fieldDescriptionInheritanceLineageEnabled',
  publishedConnectionsLineageEnabled = 'publishedConnectionsLineageEnabled',
  lensLineageEnabled = 'lensLineageEnabled',
  relevantAssetsEnabled = 'relevantAssetsEnabled',
  mixedContentConnectToDialogEnabled = 'mixedContentConnectToDialogEnabled',
  searchAndFilterOnLineagePageEnabled = 'searchAndFilterOnLineagePageEnabled',
  customSensitivityLabelsEnabled = 'customSensitivityLabelsEnabled',
  dataCloudInCatalogMVPEnabled = 'dataCloudInCatalogMVPEnabled',
}

export class FeatureFlagService {
  private featureFlagChannel = new FeatureFlagChannel();
  public static instance = new FeatureFlagService();

  public getValue(featureFlag: FeatureFlag): boolean {
    return this.featureFlagChannel.call({ featureFlag: featureFlag }).data?.featureFlagState || false;
  }
}
